<h1 data-test="snackbar-text">{{ text | translate }}</h1>

@if (actionText) {
	<button (click)="action.emit()">{{ actionText | translate }}</button>
} @else {
	<button data-test="snackbar-close-button" (click)="closeItem.emit()">{{ "actions.close" | translate }}</button>
}
